<template>
  <div class="tw-h-full">
    <div
      class="tw-h-[50px] tw-w-full tw-relative tw-z-10 tw-bg-white tw-border-b tw-border-solid tw-border-gray-200 tw-flex tw-items-center tw-justify-between tw-px-4">
      <h2 class="tw-font-semibold tw-text-lg">{{ $t('pages.dashboard.overview') }}</h2>
      <div>
        <a-button @click="show.filters = !show.filters" intent="simple" class="tw-py-0 !tw-min-h-[30px] "
          left-icon="lucide:list-filter">
          <span>{{ $t('buttons.filter') }}</span>
        </a-button>
      </div>
    </div>

    <div :class="[show.filters ? 'tw-grid-rows-[1fr]' : 'tw-grid-rows-[0fr]']"
      class="tw-grid tw-duration-300 tw-transition-all">
      <div class="tw-overflow-hidden tw-col-span-1">
            <div class="tw-h-[200px] tw-bg-white tw-w-full -tw-translate-y-1 tw-border-b tw-border-solid tw-border-gray-200">
    
            </div>
        </div>

    </div>


    <div class="tw-p-2 tw-w-full">
      <ProgressBar />
    </div>

    <div class="tw-px-2">
      <div class="tw-grid md:tw-grid-cols-2 lg:tw-grid-cols-4 tw-grid-cols-1 tw-gap-2">
        <div v-for="w in widgets" :key="w"
          class="tw-w-full tw-p-4 tw-h-[130px]  tw-bg-white tw-rounded tw-border tw-border-solid tw-border-gray-200 tw-flex tw-flex-col tw-justify-between">
          <div>
            <p class="tw-text-sm tw-font-medium tw-text-gray-500">{{ $t(w.title) }}</p>
          </div>
          <h2 class="tw-text-3xl tw-text-black tw-font-bold tw-mb-1">{{ w.value }}</h2>

          <div class="tw-flex tw-items-center tw-gap-2 ">
            <div class="tw-flex tw-items-center tw-px-1 tw-rounded tw-font-medium"
              :class="[w.color === 'green' ? 'tw-text-emerald-500 tw-bg-emerald-50' : 'tw-bg-red-50 tw-text-red-500']">
              <icon :icon="w.icon" class="tw-text-base" />
              <span class="tw-text-sm">{{ w.percentage }}</span>
            </div>
            <p class="tw-text-gray-600 tw-text-sm">{{ $t(w.comparedTo) }}</p>
          </div>
        </div>

      </div>
    </div>

    <div class="tw-px-2 tw-mt-2">
      <div class="tw-grid tw-grid-cols-12 tw-gap-2">
        <div
          class="tw-col-span-7 tw-rounded tw-w-full tw-min-h-[320px] tw-bg-white tw-border tw-border-solid tw-border-gray-200">
        </div>
        <div
          class="tw-col-span-5 tw-rounded tw-w-full tw-min-h-[320px] tw-bg-white tw-border tw-border-solid tw-border-gray-200">
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import ProgressBar from '@/components/dashboard/marketer/overview/ProgressBar.vue';

const show = ref({ filters: false });

const widgets = [
  {
    title: 'common.total-leads',
    value: '3,450',
    percentage: '20.00%',
    comparedTo: 'common.compared-to-last-month',
    icon: 'jam:arrow-up',
    color: 'green',
  },
  {
    title: 'common.total-spend',
    value: '$345.00',
    percentage: '12.00%',
    comparedTo: 'common.compared-to-last-month',
    icon: 'jam:arrow-up',
    color: 'red',
  },
  {
    title: 'common.cost-per-lead',
    value: '$2.00',
    percentage: '12.10%',
    comparedTo: 'common.compared-to-last-month',
    icon: 'jam:arrow-down',
    color: 'green',
  },
  {
    title: 'common.total-commission',
    value: '$12,456.00',
    percentage: '124.20%',
    comparedTo: 'common.compared-to-last-month',
    icon: 'jam:arrow-up',
    color: 'green',
  },

]
</script>

<style></style>